import type { ProjectStatus } from '@wd/shared';

// 16px 线性图标，路径来自设计稿 lib/ui.js。颜色默认用 --icon（比文字更暗）。

const PATHS = {
  inbox: (
    <>
      <rect x="2" y="3" width="12" height="10" rx="2" />
      <path d="M2 9h3l1 1.5h4L11 9h3" />
    </>
  ),
  doc: (
    <>
      <rect x="3" y="2" width="10" height="12" rx="2" />
      <path d="M5.5 5.5h5M5.5 8h5M5.5 10.5h3" />
    </>
  ),
  grid: (
    <>
      <rect x="2.5" y="2.5" width="4.5" height="4.5" rx="1" />
      <rect x="9" y="2.5" width="4.5" height="4.5" rx="1" />
      <rect x="2.5" y="9" width="4.5" height="4.5" rx="1" />
      <rect x="9" y="9" width="4.5" height="4.5" rx="1" />
    </>
  ),
  radar: (
    <>
      <circle cx="8" cy="8" r="5.5" />
      <circle cx="8" cy="8" r="2.5" />
      <path d="M8 8l3.5-3.5" />
    </>
  ),
  team: (
    <>
      <circle cx="6" cy="5.5" r="2.3" />
      <path d="M1.8 13c.5-2.3 2.2-3.6 4.2-3.6s3.7 1.3 4.2 3.6" />
      <circle cx="11.2" cy="6" r="1.8" />
      <path d="M11 9.6c1.6 0 2.8 1 3.2 2.9" />
    </>
  ),
  report: <path d="M3 13.5V9M6.3 13.5V5M9.7 13.5V7M13 13.5V3" />,
  search: (
    <>
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5L14 14" />
    </>
  ),
  lock: (
    <>
      <rect x="3.5" y="7" width="9" height="6.5" rx="1.5" />
      <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" />
    </>
  ),
  clock: (
    <>
      <circle cx="8" cy="8" r="5.5" />
      <path d="M8 5v3l2 1.5" />
    </>
  ),
  chevL: <path d="M10 4L6 8l4 4" />,
  chevR: <path d="M6 4l4 4-4 4" />,
  chevD: <path d="M5 6.5l3 3 3-3" />,
  chevU: <path d="M5 9.5l3-3 3 3" />,
  cal: (
    <>
      <rect x="2.5" y="3.5" width="11" height="10" rx="2" />
      <path d="M2.5 6.5h11M5.5 2v3M10.5 2v3" />
    </>
  ),
  close: <path d="M4 4l8 8M12 4l-8 8" />,
  check: <path d="M3.5 8.5l3 3 6-6.5" />,
  plus: <path d="M8 3v10M3 8h10" />,
  bell: (
    <>
      <path d="M4 11V7.5a4 4 0 0 1 8 0V11l1 1.5H3z" />
      <path d="M6.5 14h3" />
    </>
  ),
  gear: (
    <>
      <circle cx="8" cy="8" r="2.2" />
      <path d="M8 1.8v2M8 12.2v2M1.8 8h2M12.2 8h2M3.6 3.6L5 5M11 11l1.4 1.4M3.6 12.4L5 11M11 5l1.4-1.4" />
    </>
  ),
  user: (
    <>
      <circle cx="8" cy="5.5" r="2.8" />
      <path d="M2.8 14c.6-2.8 2.7-4.3 5.2-4.3s4.6 1.5 5.2 4.3" />
    </>
  ),
  clip: <path d="M12.5 7.5l-4.6 4.6a3 3 0 0 1-4.2-4.2l4.9-4.9a2 2 0 0 1 2.8 2.8L6.6 10.6a1 1 0 0 1-1.4-1.4L9.5 5" />,
  copy: (
    <>
      <rect x="5" y="5" width="8.5" height="8.5" rx="1.5" />
      <path d="M3 10.5V3.5A1 1 0 0 1 4 2.5h7" />
    </>
  ),
  send: <path d="M2.5 8L13.5 3l-3 10.5-2.5-4.5z" />,
  reply: (
    <>
      <path d="M6.5 4L3 7.5 6.5 11" />
      <path d="M3 7.5h6a4 4 0 0 1 4 4V13" />
    </>
  ),
  edit: <path d="M3 13h2.5L13 5.5 10.5 3 3 10.5z" />,
  skip: <path d="M4 4l5 4-5 4zM11.5 4v8" />,
  minus: <path d="M3.5 8h9" />,
  out: <path d="M9.5 3H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5.5M7 8h6.5M11 5.5L13.5 8 11 10.5" />,
  sun: (
    <>
      <circle cx="8" cy="8" r="2.8" />
      <path d="M8 1.5v1.5M8 13v1.5M1.5 8H3M13 8h1.5M3.4 3.4l1 1M11.6 11.6l1 1M3.4 12.6l1-1M11.6 4.4l1-1" />
    </>
  ),
  moon: <path d="M13 9.5A5.5 5.5 0 0 1 6.5 3a5.5 5.5 0 1 0 6.5 6.5z" />,
  plane: <path d="M2 9.5l12-5-3.5 9-2.5-3.5z" />,
  eye: (
    <>
      <path d="M1.5 8s2.4-4.5 6.5-4.5S14.5 8 14.5 8 12.1 12.5 8 12.5 1.5 8 1.5 8z" />
      <circle cx="8" cy="8" r="2" />
    </>
  ),
  eyeoff: (
    <path d="M2 2l12 12M6.5 4a6.6 6.6 0 0 1 1.5-.5c4.1 0 6.5 4.5 6.5 4.5a11 11 0 0 1-1.7 2.2M10 11.8a6 6 0 0 1-2 .7C3.9 12.5 1.5 8 1.5 8a11 11 0 0 1 2.3-2.8" />
  ),
  mic: (
    <>
      <rect x="5.5" y="1.8" width="5" height="8" rx="2.5" />
      <path d="M3.3 7.5a4.7 4.7 0 0 0 9.4 0M8 12.2v2" />
    </>
  ),
  export: <path d="M8 10V2.5M5 5.5l3-3 3 3M3 9.5v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3" />,
  download: <path d="M8 2.5V10M5 7l3 3 3-3M3 9.5v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3" />,
  wifioff: <path d="M2 2l12 12M5.2 8.6a4 4 0 0 1 2.3-1M2.5 6a8 8 0 0 1 2.7-1.7M10.8 8.6A4 4 0 0 0 9.6 7.8M13.5 6A8 8 0 0 0 8 3.8M8 12.2v.1" />,
  refresh: <path d="M13 8a5 5 0 1 1-1.5-3.6M13 2.5v2.5h-2.5" />,
  qr: (
    <>
      <rect x="2.5" y="2.5" width="4" height="4" rx="0.8" />
      <rect x="9.5" y="2.5" width="4" height="4" rx="0.8" />
      <rect x="2.5" y="9.5" width="4" height="4" rx="0.8" />
      <path d="M9.5 9.5h1.5v1.5M13.5 9.5v4h-2M9.5 13.5h.01" />
    </>
  ),
  mail: (
    <>
      <rect x="2" y="3.5" width="12" height="9" rx="1.8" />
      <path d="M2.5 4.5L8 8.8l5.5-4.3" />
    </>
  ),
  info: (
    <>
      <circle cx="8" cy="8" r="5.5" />
      <path d="M8 7.2v3.6M8 5.2v.01" />
    </>
  ),
  pulse: <path d="M1.5 8h3l1.5-3.5 3 7 1.5-3.5h4" />,
  list: <path d="M2.5 4h11M2.5 8h11M2.5 12h11" />,
  spark: (
    <>
      <path d="M7 2.5l1.3 3.2 3.2 1.3-3.2 1.3L7 11.5 5.7 8.3 2.5 7l3.2-1.3z" />
      <path d="M12.5 10.5v3M11 12h3" />
    </>
  ),
  board: (
    <>
      <rect x="2" y="2.5" width="3.5" height="11" rx="1" />
      <rect x="6.25" y="2.5" width="3.5" height="7" rx="1" />
      <rect x="10.5" y="2.5" width="3.5" height="9" rx="1" />
    </>
  ),
  sliders: (
    <>
      <path d="M2.5 4.5h7M12 4.5h1.5M2.5 11.5h1.5M6.5 11.5h7" />
      <circle cx="10.75" cy="4.5" r="1.5" />
      <circle cx="5.25" cy="11.5" r="1.5" />
    </>
  ),
  link: <path d="M6.5 9.5l3-3M7 4.5l1-1a2.5 2.5 0 0 1 3.5 3.5l-1 1M9 11.5l-1 1a2.5 2.5 0 0 1-3.5-3.5l1-1" />,
  square: <rect x="3" y="3" width="10" height="10" rx="2.5" />,
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 16,
  color = 'var(--icon)',
  stroke = 1.3,
  className,
}: {
  name: IconName;
  size?: number;
  color?: string;
  stroke?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flex: 'none' }}
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}

export function MoreIcon({ color = 'var(--icon)' }: { color?: string }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill={color} style={{ flex: 'none' }} aria-hidden="true">
      <circle cx="3.5" cy="8" r="1.2" />
      <circle cx="8" cy="8" r="1.2" />
      <circle cx="12.5" cy="8" r="1.2" />
    </svg>
  );
}

const STATUS_LABEL: Record<ProjectStatus, string> = {
  progress: '进行中',
  done: '已完成',
  todo: '未开始',
  blocked: '阻塞',
  cancelled: '已取消',
};

/** 项目状态图标（设计稿 StatusIcon）。dim：已处理变暗时 done 用灰色填充 */
export function StatusIcon({ status, size = 14, dim = false }: { status: ProjectStatus; size?: number; dim?: boolean }) {
  const label = STATUS_LABEL[status];
  const common = { width: size, height: size, viewBox: '0 0 14 14', fill: 'none', style: { flex: 'none' as const }, role: 'img', 'aria-label': label };
  switch (status) {
    case 'progress':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="6" stroke="var(--status-progress)" strokeWidth="1.5" />
          <path d="M7 3.5a3.5 3.5 0 0 1 0 7z" fill="var(--status-progress)" />
        </svg>
      );
    case 'blocked':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="7" fill="var(--status-blocked)" />
          <path d="M7 3.8v3.8" stroke="var(--bg-panel)" strokeWidth="1.6" strokeLinecap="round" />
          <circle cx="7" cy="10" r="0.9" fill="var(--bg-panel)" />
        </svg>
      );
    case 'todo':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="6" stroke="var(--status-todo)" strokeWidth="1.5" strokeDasharray="2.4 2.2" />
        </svg>
      );
    case 'done':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="7" fill={dim ? 'var(--status-todo)' : 'var(--status-done)'} />
          <path d="M4.2 7.2l1.9 1.9 3.7-4" stroke="var(--bg-panel)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'cancelled':
      return (
        <svg {...common}>
          <circle cx="7" cy="7" r="7" fill="var(--status-cancelled)" />
          <path d="M4.9 4.9l4.2 4.2M9.1 4.9l-4.2 4.2" stroke="var(--bg-panel)" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
  }
}
